import ChartOptions from './ChartOptions';

export default ChartOptions;
